import { SET_SHARED_BUY } from "./sharedBuysTypes";

export const setSharedBuy = (product, product_variable, quantity) => async (dispatch) => {
    dispatch({
        type: SET_SHARED_BUY,
        product,
        product_variable,
        quantity
    });
};